export const SET_DATE_DOMAIN = "SET_DATE_DOMAIN";
export const SET_LOCALE_LANG = "SET_LOCALE_LANG";
export const SET_LOCALE_MESSAGES = "SET_LOCALE_MESSAGES";

export const setDateDomain = (start, end) => {
    return {
        type: SET_DATE_DOMAIN,
        start,
        end,
    };
};

export const setLocaleLang = (lang) => {
    return {
        type: SET_LOCALE_LANG,
        lang,
    };
};

export const setMessages = (messages) => {
    return {
        type: SET_LOCALE_MESSAGES,
        messages,
    };
};
